const globalValues = ({
  maxYear: 2025 ,
  minYear: 1990
})

export default globalValues;

